var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 6.03658H30.0402L18.06 41.5327C17.9369 41.8974 17.7024 42.2144 17.3897 42.4389C17.077 42.6635 16.7018 42.7843 16.3168 42.7844H7.33541C7.04373 42.7844 6.75623 42.715 6.4967 42.5818C6.23717 42.4487 6.01307 42.2557 5.84294 42.0188C5.67281 41.7819 5.56153 41.5078 5.51832 41.2194C5.47511 40.9309 5.5012 40.6363 5.59444 40.3599L16.756 7.28823C16.8791 6.92333 17.1136 6.60623 17.4264 6.38161C17.7392 6.15699 18.1146 6.0366 18.4997 6.03658Z",
    fill: "url(#paint0_linear_6871_25115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2696 29.8447H16.969C16.7989 29.8445 16.6326 29.8956 16.4919 29.9912C16.3512 30.0869 16.2426 30.2227 16.1802 30.381C16.1177 30.5393 16.1044 30.7127 16.142 30.8786C16.1795 31.0445 16.2662 31.1953 16.3906 31.3113L28.1501 42.2872C28.4925 42.6066 28.9433 42.7842 29.4115 42.7841H39.774L35.2696 29.8447Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4993 6.03615C18.11 6.03465 17.7304 6.15768 17.416 6.38725C17.1016 6.61682 16.8688 6.94091 16.7517 7.31218L5.60779 40.3294C5.50827 40.6067 5.47703 40.904 5.5167 41.196C5.55638 41.488 5.66579 41.7662 5.8357 42.007C6.00561 42.2477 6.23101 42.444 6.49283 42.5793C6.75465 42.7145 7.0452 42.7847 7.33989 42.7839H16.5531C16.8962 42.7226 17.2169 42.5713 17.4825 42.3455C17.748 42.1197 17.9488 41.8274 18.0645 41.4986L20.2868 34.9491L28.2248 42.3531C28.5575 42.6283 28.9748 42.7804 29.4065 42.7839H39.7304L35.2024 29.8446L22.0029 29.8477L30.0815 6.03615H18.4993Z",
    fill: "url(#paint1_linear_6871_25115)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2395 7.28601C33.1166 6.9217 32.8825 6.60513 32.5701 6.3809C32.2578 6.15667 31.883 6.03609 31.4985 6.03613H18.6367C19.0212 6.03615 19.396 6.15677 19.7083 6.38099C20.0206 6.60521 20.2547 6.92174 20.3777 7.28601L31.5397 40.3591C31.633 40.6355 31.6592 40.9302 31.616 41.2187C31.5728 41.5072 31.4616 41.7813 31.2914 42.0183C31.1213 42.2554 30.8972 42.4484 30.6376 42.5817C30.3781 42.7149 30.0905 42.7843 29.7988 42.7844H42.661C42.9527 42.7843 43.2402 42.7147 43.4997 42.5815C43.7592 42.4483 43.9833 42.2552 44.1534 42.0182C44.3234 41.7812 44.4347 41.5071 44.4778 41.2186C44.521 40.9301 44.4948 40.6354 44.4015 40.3591L33.2395 7.28601Z",
    fill: "url(#paint2_linear_6871_25115)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6871_25115",
    x1: 22.7058,
    y1: 8.75972,
    x2: 10.7207,
    y2: 44.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6871_25115",
    x1: 26.4493,
    y1: 25.2599,
    x2: 23.677,
    y2: 26.1973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6871_25115",
    x1: 24.9247,
    y1: 7.72657,
    x2: 38.0808,
    y2: 42.7768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.45c08ce6d6a9aa25fe428a7d918a5106.svg";
export { ForwardRef as ReactComponent };